import React from 'react'
import PageLayout from './PageLayout'

const CookiesPolicy = () => {
  return (
    <PageLayout>
      <div className="bg-white p-4 shadow-sm rounded">

        <h3>Cookies Policy</h3>
        <p className="text-muted">Last updated: {new Date().toDateString()}</p>
        <hr />

        <h5>1. What Are Cookies?</h5>
        <p>
          Cookies are small files stored on your device to enhance browsing experience.
        </p>

        <h5>2. Why We Use Cookies</h5>
        <ul>
          <li>Remember user sessions</li>
          <li>Improve performance</li>
          <li>Analyze traffic</li>
        </ul>

        <h5>3. Types of Cookies</h5>
        <ul>
          <li><b>Essential:</b> Required for functionality</li>
          <li><b>Analytics:</b> Track usage</li>
          <li><b>Preference:</b> Save settings</li>
        </ul>

        <h5>4. Third-Party Cookies</h5>
        <p>
          We may use third-party services like analytics tools.
        </p>

        <h5>5. Managing Cookies</h5>
        <p>
          You can disable cookies in browser settings.
        </p>

        <h5>6. Updates</h5>
        <p>
          This policy may be updated periodically.
        </p>

      </div>
    </PageLayout>
  )
}

export default CookiesPolicy